/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { SectionHeader } from './main'
import SectionDivider from './sectionDivider'
import styled from 'styled-components'
import { any, bool, string } from 'prop-types'
import { getStringTime, toString } from '../../../helpers/date'
import { IconButton } from '@material-ui/core'
import { WhatsApp } from '@material-ui/icons'

const Body = styled.div`
  margin: 5em 0em;
`
const Title = styled.div`
  font-size: 2em;
  color: var(--first);
  font-family: 'imlbold'; font-weight: bold;
`
export const Row = styled.div`
  font-size: 1.2em;
  span {
    color: var(--second);
    margin-right: 1em;
  }
`

const Notice = styled.div`
  font-size: 1.23em;
  color: var(--first);
`
const Href = styled.a`
  color: var(--first);
  text-decoration: none;
`
const IconContact = styled(IconButton)`
  background: var(--second);
  padding: 5px;
  margin-right: 10px;
  svg {
    color: #fff;
    font-size: 20px;
  }
  :hover {
    background: var(--first);
  }
  @media screen and (max-width:660px) {
    padding: 5px;
    margin-right: 5px;
    svg {
      font-size: 15px;
    }
  }
`

const LinkForm = styled.a`
  color: initial;
  text-decoration: none;
  :hover {
    color: initial;
  }
`

const Send = props => {
  return (
    <SectionDivider step={5}>
      <SectionHeader
        title='Envía tu IFE/INE y comprobante de pago'
        subtitle={
          <>
            Envía un mensaje con una foto de tu INE/IFE o identificación oficial (solo el frente), el comprobante de pago en caso de transferencia y el correo de confirmación de tu cita (revisa tu SPAM).
            <br />
            <br />
            <Href href='https://api.whatsapp.com/send?phone=5214428173500' target='_blank'>
              <IconContact size='small'>
                <WhatsApp />
              </IconContact>
              WhatsApp
            </Href>
          </>
        }
      />
      <Body>
        <Title>Su cita  ha quedado registrada</Title>
        <Row><span>Nombre:</span>{props.name}</Row>
        <Row><span>Fecha</span>{toString(props.date)}</Row>
        <Row><span>Hora:</span>{getStringTime(props.date)}</Row>
        <Row><span>Correo:</span>{props.email}</Row>
        <Row><span>Estado </span>{props.isPaid ? 'Pagado' : 'No pagado'}</Row>
        <Row><span>Id: </span>{props.id}</Row>
        <br />
        <Row>
          <span>NOTA IMPORTANTE: </span>
          Si no contestaste el formulario epidemiológico en el paso 3, es OBLIGATORIO llenarlo antes de tu cita, <b><LinkForm href='https://www.laboratoriosiml.com/registro/' target='_blank'>DA CLICK AQUÍ</LinkForm></b>.  Si ya lo llenaste, omite este aviso. Gracias!
        </Row>
        <br />
        <Notice>
          *Se envió esta misma información a su correo.
        </Notice>
      </Body>
    </SectionDivider>

  )
}

Send.propTypes = {
  date: any,
  isPaid: bool,
  email: string,
  id: string,
  name: string
}

export default Send
